<template>
  <a
    :href="link + volume"
    target="_blank"
  >{{ name }}</a>
</template>

<script setup>
import { computed } from "vue";

defineProps({
  name: {
    type: String,
    default: ""
  },
  volume: {
    type: String,
    default: "#"
  }
});

const link = computed(() => `${process.env.VUE_APP_SCAN_BASE_URL}address/`);
</script>

<style scoped lang="scss"></style>
